export type UserType = {
  id: string;
  telegramId: number;
  firstName: string;
  lastName: string;
  username: string;
  languageCode: string;
  chatId?: number;
  createdAt: Date;
  status: Status;
  isTelegramUser: boolean;
  iCoreUserIds?: string[];
};

export enum Status {
  REGISTERED = "registered",
  BOT_INTERACTION_ONLY = "bot_interaction_only",
  DEPOSITED = "deposited",
}

export const usersStatusesOptions = Object.values(Status);
